import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { cta } from '../../content';
import { getWhatsAppLink } from '../../content/contentUtils';

// Valores por defecto
const defaultCta = {
  title: "¿Listo para dar el siguiente paso?",
  subtitle: "Obtén tu crédito hoy y haz realidad tus planes.",
  primaryButton: "Solicita tu crédito ahora",
  secondaryButton: "Habla con un asesor"
};

export const CTASection = () => {
  // Obtener contenido con fallbacks
  const content = {
    title: cta?.title || defaultCta.title,
    subtitle: cta?.subtitle || defaultCta.subtitle,
    primaryButton: cta?.primaryButton || defaultCta.primaryButton,
    secondaryButton: cta?.secondaryButton || defaultCta.secondaryButton
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[#013C5D] via-[#025a8a] to-[#013C5D] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#CFA935]/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#CFA935]/5 rounded-full blur-3xl" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
          {content.title}
        </h2>
        <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto">
          {content.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href={getWhatsAppLink("Hola, quiero solicitar un crédito")} target="_blank" rel="noopener noreferrer">
            <Button
              size="lg"
              className="bg-[#CFA935] hover:bg-[#b8942f] text-[#013C5D] font-semibold px-10 h-14 text-base shadow-xl hover:shadow-2xl transition-all group"
            >
              {content.primaryButton}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </a>
          <a href={getWhatsAppLink()} target="_blank" rel="noopener noreferrer">
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white/30 text-white hover:bg-white hover:text-[#013C5D] font-semibold px-10 h-14 text-base backdrop-blur-sm transition-all"
            >
              {content.secondaryButton}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
